"use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { CaretDown } from "@phosphor-icons/react";
import { cn } from "@/shared/libs/commonUtils";
import Box from "./Box";
const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ComponentRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("border-b", className)}
    {...props}
  />
));
AccordionItem.displayName = "AccordionItem";

type AccordionTriggerProps = React.ComponentPropsWithoutRef<
  typeof AccordionPrimitive.Trigger
> & {
  Icon?: React.ReactNode;
};

const AccordionTrigger = React.forwardRef<
  React.ComponentRef<typeof AccordionPrimitive.Trigger>,
  AccordionTriggerProps
>(({ className, children, Icon, ...props }, ref) => (
  // <AccordionPrimitive.Header className="flex">
  <AccordionPrimitive.Trigger
    ref={ref}
    className={cn(
      "group flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all",
      className,
    )}
    {...props}
  >
    {children}

    {Icon ? (
      <Box className="rounded-full w-6 h-6 flex items-centre justify-center shrink-0 transition-transform duration-200 group-data-[state=open]:rotate-180">
        {Icon}
      </Box>
    ) : (
      <Box className="rounded-full w-6 h-6 flex items-centre justify-center shrink-0 transition-transform duration-200 group-data-[state=open]:rotate-180">
        <CaretDown className="h-4 w-4 shrink-0 text-muted-foreground  rounded m-auto " />
      </Box>
    )}
  </AccordionPrimitive.Trigger>
  // </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ComponentRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("p-3", className)}>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
